<!--
 * @Description: 会员管理
-->
<template>
  <div>
    <div class="TableTop">
      <!-- 搜索 -->
      <div class="TableSearch">
        <el-form :model="query" @submit.native.prevent>
          <!-- 产品名 -->
          <el-form-item label="id：" class="form-item-b0">
            <el-input
              v-model="query.userId"
              placeholder="请输入userId"
              size="small"
              clearable
              @keyup.native.enter="getList('place')"
            ></el-input>
          </el-form-item>

          <el-form-item label="发票：" class="form-item-b0">
            <el-select v-model="query.isInvoiceImage" placeholder="请选择发票状态">
              <el-option label="未上传" value=""></el-option>
              <el-option label="已上传" value="1"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="订单：" class="form-item-b0">
            <el-input
              v-model="query.search"
              placeholder="请输入订单"
              size="small"
              clearable
              @keyup.native.enter="getList('place')"
            ></el-input>
          </el-form-item>
        </el-form>

        <div class="TableSearch_btn">
          <el-button type="primary" size="small" @click="getList('place')">筛选</el-button>

          <el-button size="small" @click="init()">重置</el-button>

          <el-button type="danger" size="mini" @click="exportExcels">excel</el-button>
        </div>
      </div>
    </div>

    <!-- 表格 -->
    <el-table ref="TableListRef" class="TableList" border :data="list" v-loading="loading">
      <el-table-column prop="OrderNo" label="订单编号" align="center"></el-table-column>

      <el-table-column prop="SpecName" label="规格" align="center"></el-table-column>

      <el-table-column prop="FCount" width="68" label="数量" align="center"></el-table-column>

      <el-table-column prop="Price" width="68" label="金额" align="center"></el-table-column>

      <el-table-column prop="ReceiveAddress" width="280" label="发票" align="center">
        <template slot-scope="scope">
          <div v-for="item in scope.row.invoiceJson" :key="item.key">
            {{ item.keyText + '：' + item.text }}
          </div>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="140" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="onEditInfo(scope.row)"> 上传发票 </el-button>

          <br />

          <el-button style="margin-top: 10px" type="danger" size="mini" @click="onDelInfo(scope.row)"> 删除 </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="fenye">
      <el-pagination
        class="TablePagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="query.pageindex"
        :page-sizes="[10, 20, 40, 60, 100]"
        :page-size="query.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <!-- 商户管理 -->
    <el-dialog
      :visible.sync="addDialog"
      class="FormDialogBox"
      width="680px"
      title="订单信息"
      :close-on-click-modal="false"
      append-to-body
      @close="addDialog = false"
    >
      <el-form label-width="auto" :model="addForm" ref="ruleForm">
        <el-form-item label="发票">
          <el-upload
            ref="upload"
            action="https://api.chajiuqu.com/api/current/uploadimage"
            list-type="picture-card"
            :file-list="myImage"
            multiple
            accept="image"
            :limit="1"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="danger" @click="addDetermine()"> 确 定 </el-button>
      </div>
    </el-dialog>

    <div class="pre_img" v-if="dialogVisible">
      <i class="el-icon-circle-close icon" @click="imgClose"></i>
      <el-image class="img" style="width: 20%; display: block; margin: 0 auto" :src="dialogImageUrl"></el-image>
    </div>
  </div>
</template>

<script>
import { exportExcel } from '@/utils/exportExcel'
console.log(exportExcel)

export default {
  name: 'membersIndex',
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,

      list: [],

      addDialog: false,
      addForm: {
        id: 0,
        productSpecId: 0,
        count: 1,
        price: 0,
        remark: '',
        productId: 0,
        logisticsName: '',
        logisticsNo: '',
        logisticsTime: '',
        createTime: '',
        receiveName: '',
        receivePhone: '',
        receiveAddress: '',
        receiveTime: '',
        payType: '1'
      },

      loading: true,
      total: 0,

      query: {
        pageindex: 1,
        pagesize: 20,
        categorize: 2,
        invoiceJson: '',
        isInvoiceImage: ''
      },

      keyText: {
        content: '发票内容',
        type: '发票类型',
        name: '抬头名称',
        phone: '手机号码',
        registerNo: '单位税号',
        registerAddr: '注册地址',
        registerPhone: '注册电话',
        bank: '开户银行',
        card: '银行账号',
        createTime: '申请时间'
      }
    }
  },

  created() {
    this.getList('place')
  },

  computed: {
    myImage: function () {
      const arr = []
      if (this.addForm.InvoiceImage) {
        arr.push({
          url: this.addForm.InvoiceImage
        })
      }
      return arr
    }
  },

  methods: {
    // 获取列表
    async getList(place) {
      // 重置页数
      if (place) {
        this.query.pageindex = 1
        // 滚动条回到顶部
        await this.$nextTick()
        this.$refs.TableListRef.bodyWrapper.scrollTop = 0
      }

      console.log(this.query)

      const query = {
        ...this.query
      }

      if (!query.userId) {
        delete query.userId
      }

      try {
        const { data: res } = await this.$api.order.list(query)
        console.log('获取订单列表', res)

        this.list = res.list

        this.loading = false

        this.list = res.list.map((item) => {
          const invoiceJson = JSON.parse(item.InvoiceJson)
          const arr = []

          for (const key in invoiceJson) {
            if (key !== 'status' && key !== 'src' && invoiceJson[key]) {
              arr.push({
                key,
                keyText: this.keyText[key],
                text: invoiceJson[key]
              })
            }
          }

          return {
            ...item,
            invoiceJson: arr
          }
        })
        this.total = res.count
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },

    onDelInfo(data) {
      this.$confirm('是否删除发票信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.$api.order.invoice({
          id: data.OrderId,
          invoiceJson: null,
          invoiceImage: null
        })

        this.getList()

        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      })
    },

    async onEditInfo(data) {
      const addForm = {
        ...data
      }

      this.addForm = {
        ...addForm
      }
      this.addDialog = true
    },

    async addDetermine() {
      console.log('addForm', this.addForm, this.$refs.upload.uploadFiles)

      if (this.$refs.upload.uploadFiles.length < 1) {
        this.$message.error('请上传发票图片')
        return
      }

      const imgUrl = this.$refs.upload.uploadFiles[0].response.data

      const invoiceJson = {
        src: imgUrl
      }

      this.addForm.invoiceJson.forEach((item) => {
        invoiceJson[item.key] = item.text
      })

      invoiceJson.status = 2

      const { data } = await this.$api.order.invoice({
        id: this.addForm.OrderId,
        invoiceJson: JSON.stringify(invoiceJson),
        invoiceImage: imgUrl
      })
      console.log('添加产品', data)

      this.addDialog = false
      this.getList()
    },

    async exportExcels() {
      const { data: res } = await this.$api.order.list({
        pageindex: 1,
        pagesize: 1000,
        categorize: 2,
        invoiceJson: '',
        isInvoiceImage: ''
      })
      console.log('获取订单列表', res)

      const list = res.list.sort((a, b) => {
        const ajSON = JSON.parse(a.InvoiceJson)
        const bjSON = JSON.parse(b.InvoiceJson)

        return ajSON.type.localeCompare(bjSON.type, 'zh-CN')
      })
      console.log('list', list[0])

      const headerList = [
        '订单编号',
        '商品名称',
        '规格名称',
        '商品数量',
        '商品价格',
        '发票内容',
        '发票类型',
        '抬头名称',
        '手机号码',
        '单位税号',
        '注册地址',
        '注册电话',
        '开户银行',
        '银行账号',
        '申请时间'
      ]

      exportExcel(
        list,
        headerList,
        (item) => {
          const invoiceJson = JSON.parse(item.InvoiceJson)

          return [
            item.OrderNo,
            item.Name,
            item.SpecName,
            item.FCount,
            item.Price,
            invoiceJson.content || '',
            invoiceJson.type || '',
            invoiceJson.name || '',
            invoiceJson.phone || '',
            invoiceJson.registerNo || '',
            invoiceJson.registerAddr || '',
            invoiceJson.registerPhone || '',
            invoiceJson.bank || '',
            invoiceJson.card || '',
            invoiceJson.createTime || ''
          ]
        },
        '乡里仔发票信息.xlsx'
      )
    },

    imgClose() {
      this.dialogImageUrl = ''
      this.dialogVisible = false
    },

    // 每页显示条数和当前页码
    handleSizeChange(newSize) {
      this.query.pagesize = newSize
      this.getList()
      this.$nextTick(() => {
        this.$refs.TableListRef.bodyWrapper.scrollTop = 0
      })
    },
    handleCurrentChange(newPage) {
      this.query.pageindex = newPage
      this.getList()
      this.$nextTick(() => {
        this.$refs.TableListRef.bodyWrapper.scrollTop = 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .data-list {
  width: 620px !important;

  ul.el-scrollbar__view {
    display: flex;
    flex-wrap: wrap;
  }
}

.auditImg {
  display: flex;
  .block {
    margin-right: 25px;
    span {
      display: block;
      width: 120px;
      text-align: center;
    }
    img {
      width: 120px;
    }
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.pre_img {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 99999988;
  display: flex;
  align-items: center;
  justify-content: center;

  .icon {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 60px;
    top: 60px;
    font-size: 40px;
    color: rgba(255, 255, 255, 0.6);
    cursor: pointer;
  }

  .img {
    width: 20%;
    display: block;
  }
}
</style>
